import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=236b2438&scoped=true&"
import script from "./Pay.vue?vue&type=script&lang=ts&"
export * from "./Pay.vue?vue&type=script&lang=ts&"
import style0 from "./Pay.vue?vue&type=style&index=0&id=236b2438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236b2438",
  null
  
)

export default component.exports